export const SET_PROFILES = 'SET_PROFILES';
export const SET_PROFILES_LOADING = 'SET_PROFILES_LOADING';
export const SET_PAGINATION_DATA = 'SET_PAGINATION_DATA';
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE';
